import React from 'react'
import './GateBanner.scss'

const GateBanner = ({
  title,
  text,
  backgroundImageUrl = null,
  mobileBackgroundImageUrl = null,
  button = null,
}) => {
  return (
    <div className="gate-banner themed-secondary">
      {/* these pixel widths (480/800) aren't correct. they symbolize mobile and not mobile.*/}
      {backgroundImageUrl && mobileBackgroundImageUrl && (
        <picture className="background">
          <source srcSet={backgroundImageUrl} media="(min-width: 600px)" />
          <source
            srcSet={mobileBackgroundImageUrl}
            media="(max-width: 599px)"
          />
          <img alt="gate banner" src={mobileBackgroundImageUrl} />
        </picture>
      )}

      <div className="container f">
        <div className="message">
          <h1 dangerouslySetInnerHTML={{ __html: title }} />
          <div className="copy" dangerouslySetInnerHTML={{ __html: text }} />
          {button}
        </div>
      </div>
    </div>
  )
}

export default GateBanner
